export default __webpack_public_path__ + "static/media/1224.1a3dc8da.png";